export const RECAPTCHA_CONSTANT_REQUEST = "RECAPTCHA_CONSTANT_REQUEST";
export const RECAPTCHA_CONSTANT_SUCCESS = "RECAPTCHA_CONSTANT_SUCCESS";
export const RECAPTCHA_CONSTANT_FAIL = "RECAPTCHA_CONSTANT_FAIL";
export const RECAPTCHA_CONSTANT_RESET = "RECAPTCHA_CONSTANT_RESET";
